import { apiRequest, announcementDetail } from "../../../../services/adapters/base";

class DetailRepository {
	fetchDetail = async (query) => {
		return await apiRequest(
			"get",
			announcementDetail,
			{
				params: query,
			},
			true
		);
	};
}

export default DetailRepository;
